import React, { useEffect, useState } from "react";
import SideBar from "./SideBar";
import VideoSelection from "./VideoSelection";
import FileUpload from "./FileUpload";
import { useDispatch } from "react-redux";
import { getSubtitles } from "../../thunks/editor/scriptThunks";

const VideoPopover = () => {
  const dispatch = useDispatch();
  const [selectedTab, setSelectedTab] = useState(0);
  const onUpload = () => {
    dispatch(getSubtitles());
    setSelectedTab(0);
  };

  return (
    <div className="flex">
      <SideBar selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
      {selectedTab ? (
        <div className="bg-[#F4F3F6] h-[467px]] w-[506px] p-[15px] pt-5">
          <div className="font-semibold text-sm	text-[#11142DB2] pb-[11px]">
            Upload Video
          </div>
          <div className="pt-[64px]">
            <FileUpload onUpload={onUpload} accept="video/*" />
          </div>
        </div>
      ) : (
        <VideoSelection />
      )}
    </div>
  );
};

export default VideoPopover;
